import { DateTime } from "luxon";

export const CHART_DATE_FORMAT = `MMM d, yyyy`;
export const CHART_DATE_FORMAT_MONTH_SHORT = `MMM`;
export const CHART_DATE_FORMAT_MONTH = 'MMMM';
export const CHART_DATE_FORMAT_DATE_SHORT  = `d`;
export const CHART_DATE_FORMAT_YEAR_SHORT  = `yyyy`;
export const DATE_FORMAT_CUSTOM_VALUE = `yyyy-MM-dd`;

export const YAXIS_TICKS_APPROXIMATE = 8;
export const UNCERTAIN_THRESHOLD = 1000;
export const UNCERTAIN_PCT_THRESHOLD = 0.6;

export const MAX_SUBVARIANTS_SELECTED = 6;

export const EARLIEST_DATA_DATE = DateTime.fromISO('2019-12-01');

export const MOUSE_PROXIMITY = 45;

export const PROVINCE_SEPARATOR = '--';

export const MAX_PREDICTION_SUBVARIANTS = 10;
export const MAX_LOCATIONS_GRID_MODE = 6;

export const QUALITY_THRESHOLD = 0.02; // A week has to have more than this % of the sequences in order to be 'valid' for lineage purposes
